export enum VendorCommandsEnum {
    SKIP_FREE_GAMES = "SKIP_FREE_GAMES",
    TOGGLE_BUY_FEATURE = "TOGGLE_BUY_FEATURE",
    FEATURE_BYE_SPIN = "FEATURE_BYE_SPIN",
    CANCEL_FREE_GAMES = "CANCEL_FREE_GAMES"
}
